var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14.769,
    viewBox: "0 0 16 14.769",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/location"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 8.265a1.92 1.92 0 1 0 0 -3.84 1.92 1.92 0 0 0 0 3.84Z",
    stroke: "#1D2023",
    strokeWidth: 1.476923076923077
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.843 5.225c1.214 -5.329 9.108 -5.323 10.314 0.006 0.709 3.126 -1.236 5.772 -2.942 7.409a3.196 3.196 0 0 1 -4.436 0c-1.698 -1.637 -3.643 -4.289 -2.935 -7.415Z",
    stroke: "#1D2023",
    strokeWidth: 1.476923076923077
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.62efb22298f1df64dd838748826fda63.svg";
export { ForwardRef as ReactComponent };